export enum ViewSummaryAlignType {
  Simple = 'simpleAlign',
  Grid = 'gridAlign',
}
